import InputComp from "themes/elements/Input";
import SummerNote from "themes/elements/SummerNote";
import TextAreaComp from "themes/elements/TextArea";
import style from "../../../CreateNotification/create_noti.module.scss";

function RightSection(props) {
  const { setTitle, title, message, setMessage, abstract, setAbstract } = props;

  return (
    <div className={`flex flex-column gap-4 w-full ${style["right-section"]}`}>
      {/*Title */}
      <InputComp
        label="Title"
        placeholder="Provide title of the article"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        maxLength={200}
        showCount={true}
      />
      <TextAreaComp
        maxValue={300}
        label="Description"
        placeholder="Provide description content to the article"
        value={abstract}
        onChange={(e) => setAbstract(e.target.value)}
      />
      {/* Message  Content */}
      <SummerNote
        initialContent={message}
        onChange={(value) => {
          setMessage(value);
        }}
      />
    </div>
  );
}

export default RightSection;
